import type { Stock } from '@oneaudi/onegraph-client';
import type { AsyncStateHolder } from './FeatureHubAppDefinition';
import type { AppTheme } from './context/ContextTypes';

export interface BaseCta {
  readonly disabled?: boolean;
  readonly role?: string;
}
export interface Link extends BaseCta {
  readonly text: string;
  readonly href: string;
  readonly opensInNewTab?: boolean | null;
  readonly ariaLabel?: string | null;
}
export interface SecondaryCta extends BaseCta {
  readonly secondaryOptions: string;
  readonly shopNowCta: ShopNow;
  readonly customCta: CustomCta;
}
export interface ShopNow extends BaseCta {
  readonly text: string;
  readonly carlineId: string;
}
export interface CustomCta extends BaseCta {
  readonly text: string;
  readonly href: string;
  readonly ariaLabel?: string | null;
}
export interface LinkWithCurrentPage extends Link {
  readonly currentPage: boolean | null;
}

export type CarlineAvailableStock = {
  readonly name: string;
  readonly newCars?: Stock;
  readonly usedCars?: Stock;
};
export interface ContentProps {
  readonly i18nMessages?: I18nMessages;
}
export interface Content {
  readonly headline: string;
  readonly links: LinkWithCurrentPage[];
  readonly cta: Link[];
  readonly secondaryCta: SecondaryCta;
  readonly lightDarkMode: AppTheme;
  readonly stickyMode: StickyMode;
  readonly fascinationMode: boolean;
}
export interface HeadlessContent {
  readonly __type: string;
  readonly fields: {
    readonly headline: string;
    readonly cta_0_text: string | null;
    readonly cta_0_href: string | null;
    readonly cta_0_ariaLabel: string | null;
    readonly cta_0_opensInNewTab: boolean | null;
    readonly secondaryCta_shopNowCta_text: string | null;
    readonly secondaryCta_shopNowCta_carlineId: string | null;
    readonly secondaryCta_customCta_text: string | null;
    readonly secondaryCta_customCta_href: string | null;
    readonly secondaryCta_customCta_ariaLabel: string | null;
    readonly lightDarkMode: AppTheme;
    readonly stickyMode: StickyMode;
    readonly secondaryCta_secondaryOptions: string;
    readonly links: {
      readonly fields: LinkWithCurrentPage;
    }[];
    readonly fascinationMode: boolean | null;
  };
}

export interface AsyncFeatureAppProps {
  readonly asyncStateHolder: AsyncStateHolder;
}

export type I18nMessages = Record<I18nMessageKey, string>;

export type I18nMessageKey =
  | 'newCars'
  | 'usedCars'
  | 'available'
  | 'ariaMenu'
  | 'ariaSubmenu'
  | 'ariaScrollLeft'
  | 'ariaScrollRight'
  | 'ariaDirectNavigation';

export enum StickyMode {
  STICKY = 'sticky',
  NONE = 'none',
}

export interface I18nTexts {
  [key: string]: string;
}

export enum SECONDARYOPTIONS {
  NONE = 'none',
  VTP = 'vtp',
  CUSTOM = 'custom',
}

export enum TRIGGERID {
  DESKTOP = 'menu-trigger-desktop',
  MOBILE = 'menu-trigger-mobile',
}

export enum SUBMENUID {
  DESKTOP = 'submenu-desktop',
  MOBILE = 'submenu-mobile',
}
